import React, { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../services/SellingService";
import BcProductTable from "../formule/partenaire/BcProductTable";

const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };
const labelStyle = {
  fontSize: "0.8rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.03em",
  color: "#6c757d",
};

const BCProduct = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [showElement] = useState(JSON.parse(localStorage.getItem("status")));
  const [data, setData] = useState({});
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [alert, setAlert] = useState({ open: false, text: "" });

  const handleAlertClose = (event, reason) => {
    if (reason !== "clickaway") setAlert((a) => ({ ...a, open: false }));
  };

  const loadProducts = (begin = dateDebut, end = dateFin) => {
    if (begin && end && begin > end) {
      setAlert({ open: true, text: "La date de début doit être antérieure à la date de fin" });
      return;
    }
    // Backend expects "any" when no date, and a full timestamp otherwise.
    const dateD = begin ? `${begin}T00:00:00` : "any";
    const dateF = end ? `${end}T23:59:59` : "any";

    setData({});
    startLoading();
    SellingService.getProductsInBonCommandesSalesByDate(getCurrentUserId(), dateD, dateF)
      .then((response) => setData(response.data))
      .catch(() =>
        setAlert({ open: true, text: "Erreur : impossible de charger les produits" })
      )
      .finally(() => {
        setLoaded(true);
        stopLoading();
      });
  };

  useEffect(() => {
    loadProducts();
  }, []);

  const onReset = () => {
    setDateDebut("");
    setDateFin("");
    loadProducts("", "");
  };

  const hasData = data && Object.keys(data).length > 0;
  const isB2BUser = showElement?.includes("USER_B2B");

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-boxes mr-2"></i>Produits des bons de commande de vente
              </h4>
              <small className="text-muted">
                Quantités à préparer et cartons par produit
              </small>
            </div>
            <button
              className="btn btn-outline-secondary mt-2 mt-sm-0"
              onClick={() => navigate("/bonCommandeVente")}
            >
              <i className="fas fa-arrow-left mr-1"></i>
              Retour aux bons de commande
            </button>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          {!isB2BUser && (
            <div className="card card-outline card-dark mt-3" style={cardStyle}>
              <div className="card-header">
                <h3 className="card-title">
                  <i className="fas fa-filter mr-2"></i>Filtres
                </h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="bcDateDebut" style={labelStyle}>
                        Date début
                      </label>
                      <input
                        id="bcDateDebut"
                        className="form-control"
                        type="date"
                        value={dateDebut}
                        max={dateFin || undefined}
                        onChange={(e) => setDateDebut(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="bcDateFin" style={labelStyle}>
                        Date fin
                      </label>
                      <input
                        id="bcDateFin"
                        className="form-control"
                        type="date"
                        value={dateFin}
                        min={dateDebut || undefined}
                        onChange={(e) => setDateFin(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn btn-outline-dark mr-2" onClick={onReset}>
                  <i className="fas fa-undo mr-1"></i> Réinitialiser
                </button>
                <button className="btn btn-dark" onClick={() => loadProducts()}>
                  <i className="fas fa-search mr-1"></i> Confirmer
                </button>
              </div>
            </div>
          )}

          {hasData && <BcProductTable date={new Date().toISOString().split("T")[0]} data={data} />}
          {loaded && !hasData && (
            <div className="alert alert-info mt-3">
              Aucun produit trouvé pour cette période.
            </div>
          )}
        </div>
      </section>

      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleAlertClose} severity="error">
          {alert.text}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default withLoader(BCProduct);
